/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Announcement
 */
export interface Announcement {
    /**
     * 
     * @type {string}
     * @memberof Announcement
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof Announcement
     */
    shortDescription: string;
    /**
     * 
     * @type {string}
     * @memberof Announcement
     */
    description: string;
    /**
     * 
     * @type {Date}
     * @memberof Announcement
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof Announcement
     */
    displayStart: Date;
    /**
     * 
     * @type {Date}
     * @memberof Announcement
     */
    displayEnd: Date;
}

/**
 * Check if a given object implements the Announcement interface.
 */
export function instanceOfAnnouncement(value: object): value is Announcement {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('shortDescription' in value) || value['shortDescription'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('displayStart' in value) || value['displayStart'] === undefined) return false;
    if (!('displayEnd' in value) || value['displayEnd'] === undefined) return false;
    return true;
}

export function AnnouncementFromJSON(json: any): Announcement {
    return AnnouncementFromJSONTyped(json, false);
}

export function AnnouncementFromJSONTyped(json: any, ignoreDiscriminator: boolean): Announcement {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'shortDescription': json['shortDescription'],
        'description': json['description'],
        'createdAt': (new Date(json['createdAt'])),
        'displayStart': (new Date(json['displayStart'])),
        'displayEnd': (new Date(json['displayEnd'])),
    };
}

export function AnnouncementToJSON(json: any): Announcement {
    return AnnouncementToJSONTyped(json, false);
}

export function AnnouncementToJSONTyped(value?: Announcement | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'shortDescription': value['shortDescription'],
        'description': value['description'],
        'createdAt': value['createdAt'].toISOString(),
        'displayStart': value['displayStart'].toISOString(),
        'displayEnd': value['displayEnd'].toISOString(),
    };
}

